<template>
    <div class="basic_wrap">
        <div class="red_top_bg">
            <div class="search_box" @click="$router.push('/search')">
                <i class="fdj"></i>
                <input type="text" readonly placeholder="搜索商品名称" class="search_inp">
                <div class="clear_inp"></div>
            </div>
        </div>
        <div class="item_wrap">
            <div class="left_type">
                <div class="type_list" v-for="(item, idx) in data" :key="item.id" :class="idx== current?'cur':''" @click="choostShop(idx)"><i></i><img v-if="item.img1" class="tl_icon" :src="item.img1" @error="onIconError(item)"><span v-else class="tl_icon" v-html="typeIcon(item.name)"></span><span class="tl_name">{{item.name}}</span></div>
            </div>
            <div class="right_content">
                <div v-if="isGoodsLoading" class="loading_text">加载中...</div>
                <div v-else-if="goodsList.length" class="goods_list">
                    <div class="goods_item" v-for="item in goodsList" :key="item.id" @click="shopGo(item.id)">
                        <img v-if="item.img" :src="item.img" alt="" @error="onImgError(item)">
                        <div v-else class="goods_empty_img"></div>
                        <p class="goods_name van-multi-ellipsis--l2">{{item.title}}</p>
                        <div class="goods_price">¥{{showPrice(item)}}</div>
                    </div>
                </div>
                <div v-else class="empty_text">该分类下暂无商品</div>
            </div>
        </div>
    </div>
</template>

<script>
    import Fetch from '../../utils/fetch';

    // 分类图标（lucide 线性图标，分类名 → SVG）
    const svg = (inner) => `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">${inner}</svg>`;
    const TYPE_ICONS = {
        '油卡充值': svg('<line x1="3" x2="15" y1="22" y2="22"/><line x1="4" x2="14" y1="9" y2="9"/><path d="M14 22V4a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v18"/><path d="M14 13h2a2 2 0 0 1 2 2v2a2 2 0 0 0 2 2a2 2 0 0 0 2-2V9.83a2 2 0 0 0-.59-1.42L18 5"/>'),
        '电商卡劵': svg('<path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/>'),
        '家用电器': svg('<path d="M5 6a4 4 0 0 1 4-4h6a4 4 0 0 1 4 4v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6Z"/><path d="M5 10h14"/><path d="M15 7v6"/>'),
        '生活家居': svg('<path d="M20 9V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v3"/><path d="M2 16a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-5a2 2 0 0 0-4 0v1.5a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5V11a2 2 0 0 0-4 0z"/><path d="M4 18v2"/><path d="M20 18v2"/><path d="M12 4v9"/>'),
        '精品饰品': svg('<path d="M6 3h12l4 6-10 13L2 9Z"/><path d="M11 3 8 9l4 13 4-13-3-6"/><path d="M2 9h20"/>'),
        '手机数码': svg('<rect width="14" height="20" x="5" y="2" rx="2" ry="2"/><path d="M12 18h.01"/>'),
        '母婴': svg('<path d="M10 16c.5.3 1.2.5 2 .5s1.5-.2 2-.5"/><path d="M15 12h.01"/><path d="M19.38 6.813A9 9 0 0 1 20.8 10.2a2 2 0 0 1 0 3.6 9 9 0 0 1-17.6 0 2 2 0 0 1 0-3.6A9 9 0 0 1 12 3c2 0 3.5 1.1 3.5 2.5s-.9 2.5-2 2.5c-.8 0-1.5-.4-1.5-1"/><path d="M9 12h.01"/>'),
        '运动产品': svg('<path d="M17.596 12.768a2 2 0 1 0 2.829-2.829l-1.768-1.767a2 2 0 0 0 2.828-2.829l-2.828-2.828a2 2 0 0 0-2.829 2.828l-1.767-1.768a2 2 0 1 0-2.829 2.829z"/><path d="m2.5 21.5 1.4-1.4"/><path d="m20.1 3.9 1.4-1.4"/><path d="M5.343 21.485a2 2 0 1 0 2.829-2.828l1.767 1.768a2 2 0 1 0 2.829-2.829l-6.364-6.364a2 2 0 1 0-2.829 2.829l1.768 1.767a2 2 0 0 0-2.828 2.829z"/><path d="m9.6 14.4 4.8-4.8"/>'),
        '时尚服装': svg('<path d="M20.38 3.46 16 2a4 4 0 0 1-8 0L3.62 3.46a2 2 0 0 0-1.34 2.23l.58 3.47a1 1 0 0 0 .99.84H6v10c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V10h2.15a1 1 0 0 0 .99-.84l.58-3.47a2 2 0 0 0-1.34-2.23z"/>'),
        '情趣用品': svg('<path d="M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z"/>'),
        '休闲鞋类': svg('<path d="M4 16v-2.38C4 11.5 2.97 10.5 3 8c.03-2.72 1.49-6 4.5-6C9.37 2 10 3.8 10 5.5c0 3.11-2 5.66-2 8.68V16a2 2 0 1 1-4 0Z"/><path d="M20 20v-2.38c0-2.12 1.03-3.12 1-5.62-.03-2.72-1.49-6-4.5-6C14.63 6 14 7.8 14 9.5c0 3.11 2 5.66 2 8.68V20a2 2 0 1 0 4 0Z"/><path d="M16 17h4"/><path d="M4 13h4"/>'),
        '舒适家纺': svg('<path d="M2 20v-8a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v8"/><path d="M4 10V6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v4"/><path d="M12 4v6"/><path d="M2 18h20"/>'),
        '高端名酒': svg('<path d="M8 22h8"/><path d="M7 10h10"/><path d="M12 15v7"/><path d="M12 15a5 5 0 0 0 5-5c0-2-.5-4-2-8H9c-1.5 4-2 6-2 8a5 5 0 0 0 5 5Z"/>'),
        '办公用品': svg('<path d="M15.707 21.293a1 1 0 0 1-1.414 0l-1.586-1.586a1 1 0 0 1 0-1.414l5.586-5.586a1 1 0 0 1 1.414 0l1.586 1.586a1 1 0 0 1 0 1.414z"/><path d="m18 13-1.375-6.874a1 1 0 0 0-.746-.776L3.235 2.028a1 1 0 0 0-1.207 1.207L5.35 15.879a1 1 0 0 0 .776.746L13 18"/><path d="m2.3 2.3 7.286 7.286"/><circle cx="11" cy="11" r="2"/>'),
        '箱包': svg('<path d="M16 20V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/><rect width="20" height="14" x="2" y="6" rx="2"/>'),
        '内衣': svg('<path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"/>'),
        '美妆': svg('<path d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z"/><path d="M20 3v4"/><path d="M22 5h-4"/><path d="M4 17v2"/><path d="M5 18H3"/>'),
        '洗护': svg('<path d="M3 3h.01"/><path d="M7 5h.01"/><path d="M11 7h.01"/><path d="M3 7h.01"/><path d="M7 9h.01"/><path d="M3 11h.01"/><rect width="4" height="4" x="15" y="5"/><path d="m19 9 2 2v10c0 .6-.4 1-1 1h-6c-.6 0-1-.4-1-1V11l2-2"/><path d="m13 14 8-2"/><path d="m13 19 8-2"/>'),
        '__default': svg('<path d="M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z"/><circle cx="7.5" cy="7.5" r=".5" fill="currentColor"/>')
    };

    export default {
        name: "item",
        data() {
            return {
                data: [],
                current: 0,
                goodsList: [],
                isGoodsLoading: false,
                goodsCache: {},
                goodsReqToken: 0
            }
        },
        created() {
            this.$parent.footer('item');
        },
        mounted() {
            this.start();
        },
        methods: {
            start() {
                Fetch('/index/item_class').then((r) => {
                    this.data = r.data || [];
                    if (this.data.length) {
                        const savedIdx = parseInt(sessionStorage.getItem('item_current_idx') || '0');
                        if (!isNaN(savedIdx) && savedIdx >= 0 && savedIdx < this.data.length) {
                            this.current = savedIdx;
                        }
                        this.loadGoods(this.data[this.current].id);
                    }
                })
            },
            loadGoods(id) {
                if (this.goodsCache[id] !== undefined) {
                    this.goodsList = this.goodsCache[id];
                    return;
                }
                this.isGoodsLoading = true;
                const token = ++this.goodsReqToken;
                Fetch('/index/item_search', {
                    first_cats: id,
                    sort_type: 1
                }).then((r) => {
                    if (token !== this.goodsReqToken) return;
                    const list = (r.data && r.data.list) ? r.data.list : [];
                    this.goodsList = list;
                    this.goodsCache[id] = list;
                }).catch(() => {}).then(() => {
                    if (token !== this.goodsReqToken) return;
                    this.isGoodsLoading = false;
                });
            },
            showPrice(item) {
                var price = parseFloat(item.price);
                if (isNaN(price) || price <= 0) {
                    price = parseFloat(item.min) || 0;
                }
                return price.toFixed(2);
            },
            onImgError(item) {
                if (!item) return;
                this.$set(item, 'img', '');
            },
            typeIcon(name) {
                return TYPE_ICONS[name] || TYPE_ICONS.__default;
            },
            onIconError(item) {
                if (!item) return;
                this.$set(item, 'img1', '');
            },
            shopGo(id) {
                this.$router.push('/details/' + id);
            },
            choostShop(idx) {
                this.current = idx;
                if (this.data[idx]) {
                    sessionStorage.setItem('item_current_idx', String(idx));
                    this.loadGoods(this.data[idx].id);
                }
            }
        },
    }
</script>

<style lang="less" scoped>
    .red_top_bg {
        position: fixed;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        z-index: 10;
    }

    .basic_wrap {
        position: relative;
    }

    .search_box {
        width: 343px;
        height: 32px;
        background-color: rgba(255, 255, 255, 0.92);
        border-radius: 18px;
        margin: 8px auto 0 auto;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding: 0 10px 0 14px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);

        .fdj {
            width: 16px;
            height: 16px;
            background: url(../images/item/fdj.png) no-repeat center center;
            background-size: 100% 100%;
            opacity: 0.8;
        }

        .search_inp {
            flex: 1;
            margin: 0 8px;
            font-size: 14px;
            color: #000000;
            line-height: 20px;
            height: 20px;

            &::placeholder {
                color: rgba(0, 0, 0, 0.35);
            }
        }

        .clear_inp {
            width: 20px;
            height: 20px;
            background: url(../images/item/clear.png) no-repeat center center;
            background-size: 100% 100%;
            opacity: 0.25;
        }
    }

    .left_type::-webkit-scrollbar,
    .right_content::-webkit-scrollbar {
        display: none;
    }

    .item_wrap {
        width: 375px;
        display: flex;
        justify-content: space-between;
        height: 100%;
        padding: 44px 0 49px 0;
        overflow: hidden;
        position: fixed;
        transform: translateX(-50%);
        top: 0;
        left: 50%;

        .left_type {
            width: 96px;
            height: 100%;
            overflow-y: scroll;
            -webkit-overflow-scrolling: touch;
            background-color: #f7f7f7;

            .type_list {
                width: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                gap: 5px;
                position: relative;
                height: 46px;
                transform: translateZ(0);
                padding: 0 10px;

                &:active {
                    transform: translateZ(0) scale(0.98);
                }

                i {
                    position: absolute;
                    width: 3px;
                    height: 18px;
                    background-color: #E3382E;
                    left: 0;
                    display: block;
                    opacity: 0;
                    border-radius: 2px;
                }

                .tl_icon {
                    width: 20px;
                    height: 20px;
                    flex-shrink: 0;
                    color: rgba(0, 0, 0, 0.38);

                    svg {
                        width: 100%;
                        height: 100%;
                        display: block;
                    }
                }

                img.tl_icon {
                    display: block;
                    object-fit: contain;
                }

                .tl_name {
                    font-size: 13px;
                    color: rgba(0, 0, 0, 0.6);
                    text-align: center;
                    line-height: 18px;
                    white-space: nowrap;
                }

                &.cur {
                    background: #ffffff;
                    font-weight: bold;

                    i {
                        opacity: 1;
                    }

                    .tl_icon {
                        color: #E3382E;
                    }

                    .tl_name {
                        font-size: 14px;
                        color: rgba(0,0,0,.8);
                    }
                }
            }
        }

        .right_content {
            flex: 1;
            height: 100%;
            overflow-y: scroll;
            -webkit-overflow-scrolling: touch;
            padding: 12px 12px 10px;
            background: #fafafa;

            .goods_list {
                display: grid;
                grid-template-columns: repeat(2, 1fr);
                gap: 12px;
            }

            .goods_item {
                width: 100%;
                margin: 0;
                transform: translateZ(0);
                background: #ffffff;
                border-radius: 10px;
                padding: 10px;
                box-shadow: 0 6px 16px rgba(0, 0, 0, 0.06);

                &:active {
                    transform: translateZ(0) scale(0.98);
                }

                img,
                .goods_empty_img {
                    display: block;
                    width: 100%;
                    height: 120px;
                    border-radius: 8px;
                    background: #f5f5f5;
                }

                img {
                    object-fit: cover;
                }

                .goods_name {
                    width: 100%;
                    min-height: 36px;
                    line-height: 18px;
                    font-size: 13px;
                    color: rgba(0, 0, 0, 0.7);
                    margin-top: 8px;
                }

                .goods_price {
                    line-height: 18px;
                    font-size: 14px;
                    color: #F03041;
                    font-weight: bold;
                    margin-top: 4px;
                }
            }

            .empty_text {
                padding-top: 80px;
                text-align: center;
                font-size: 13px;
                color: rgba(0, 0, 0, 0.45);
            }

            .loading_text {
                padding-top: 80px;
                text-align: center;
                font-size: 13px;
                color: rgba(0, 0, 0, 0.45);
            }
        }
    }
</style>
